import PocketBase from 'pocketbase';

const pb = new PocketBase('https://infocolab.infocolab.online');
pb.autoCancellation(false);

export default pb;
